import type { SelectableIcons } from '@frontend/shared';

export const TOP_BAR_MODAL_EVENT = 'top-bar:modal';

export type TopBarModalEventDetail = { action: 'open'; icon?: SelectableIcons } | { action: 'close' };

export const dispatchTopBarModalOpen = (icon?: SelectableIcons) => {
  const ev = new CustomEvent<TopBarModalEventDetail>(TOP_BAR_MODAL_EVENT, { detail: { action: 'open', icon } });
  window.dispatchEvent(ev);
};

export const dispatchTopBarModalClose = () => {
  const ev = new CustomEvent<TopBarModalEventDetail>(TOP_BAR_MODAL_EVENT, { detail: { action: 'close' } });
  window.dispatchEvent(ev);
};
